export interface DSExampleBase {
    description?: string;
}

export interface DSReactExampleJSX {
    jsx: string;
}

export interface DSReactExampleComponent {
    react: string;
}

export type DSReactExample = DSExampleBase & (DSReactExampleComponent | DSReactExampleJSX);

export interface DSAngularExample extends DSExampleBase {
    template: string;
    class?: string;
}

export type DSExample = DSReactExample | DSAngularExample;

export function exampleIsReactComponentExample(example: DSExample): example is DSReactExampleComponent {
    return example.hasOwnProperty("react");
}

export function exampleIsReactJSXExample(example: DSExample): example is DSReactExampleJSX {
    return example.hasOwnProperty("jsx");
}

export interface DSExamplesTab<T extends DSExample = DSExample> {
    label?: string;
    description?: string;
    examples: {
        [key: string]: T;
    };
}

export interface DSExamples<T extends DSExample = DSExample> {
    [key: string]: DSExamplesTab<T>;
}

export type DSReactExamples = DSExamples<DSReactExample>;
export type DSAngularExamples = DSExamples<DSAngularExample>;
